import type { PlannedLine } from '../budget/cashflow';
import { openItems } from './items';
import type { ShoppingItemLike } from './types';

export const SHOPPING_PLANNED_KEY = 'shopping';
export const SHOPPING_PLANNED_LABEL = 'On your shopping list';

/**
 * Open items with an estimate, as Budget's planned-spending line (spec §6: "₱3,200 left · ₱850 on
 * your shopping list"). Shown beside What's left, never subtracted until bought.
 */
export function plannedShopping(items: readonly ShoppingItemLike[]): PlannedLine[] {
  const lines = openItems(items).filter((i) => (i.estimateMinor ?? 0) > 0);
  if (lines.length === 0) return [];
  return [
    {
      key: SHOPPING_PLANNED_KEY,
      label: SHOPPING_PLANNED_LABEL,
      items: lines.map((i) => ({ id: i.id, label: i.name, amountMinor: i.estimateMinor! })),
    },
  ];
}
